var colors = ['#FDA370','#FEB202','#FF7CFA','#8260FF','#F3F957','#06AE4A'];
document.addEventListener('DOMContentLoaded',function(){
    let elements = document.querySelectorAll('.hdt-navigation > #hdt-nav-ul > .hdt-menu-item');

    elements.forEach((element) => {
        element.addEventListener('mouseenter', function (ev) {
            let randomColor = colors[Math.floor(Math.random() * colors.length)];
            ev.currentTarget.style.background = randomColor;
        });

        element.addEventListener('mouseleave', function (ev) {
            if (!ev.relatedTarget || !element.contains(ev.relatedTarget)) {
                ev.currentTarget.style.background = "";
            }
        });
    });

    // Animacion contador
    const targets = document.querySelectorAll('.tlg-enabled-animation');
    if(targets.length > 0){
        targets.forEach(target => {
            const counter_numeros = target.querySelectorAll('.tlg-counter-numbers');
            const intersectionObserver = new IntersectionObserver((entries, observer) =>{
                entries.forEach(entry => {
                    if (entry.isIntersecting){
                        target.classList.add('tlg-custom-icons-animation');

                        counter_numeros.forEach((item) => {
                            const partes =  item.textContent.trim().split(' ');
                            const restoTexto = partes.slice(1).join(' ');

                            if(!isNaN(partes[0])){
                                const numeroFinal = parseInt(partes[0].replace(/\./g, ''));

                                let duration = 2000;
                                let startTime = null;
            
                                const animar = (timestamp) => {
                                    if (!startTime) startTime = timestamp;
                                    const progreso = timestamp - startTime;
                                    const porcentaje = Math.min(progreso / duration, 1);
                                    const valorActual = Math.floor(porcentaje * numeroFinal);
            
                                    item.textContent = valorActual.toLocaleString('es-ES') + ' ' + restoTexto;

                                    (porcentaje < 1) ? requestAnimationFrame(animar) : null;
                                };

                                requestAnimationFrame(animar);
                            }
                        });

                        intersectionObserver.unobserve(target);
                    }
                });

            }, {
                threshold: 0.3
            });
        
            intersectionObserver.observe(target);
        });
    }
});
